"use client";

import { useMemo } from "react";

import { useI18n } from "@llmgateway/i18n/react";
import {
	DEFAULT_INTEGRATION_GUIDES,
	IntegrationGuidesGrid,
} from "@llmgateway/shared/components";

import type { IntegrationGuide } from "@llmgateway/shared/components";

const GUIDE_DESCRIPTION_KEYS: Record<string, string> = {
	"/guides/autohand": "guides.descriptions.autohand",
	"/guides/claude-code": "guides.descriptions.claudeCode",
	"https://docs.doteb.com/guides/cursor": "guides.descriptions.cursor",
	"/guides/codex-cli": "guides.descriptions.codexCli",
	"https://docs.doteb.com/guides/cline": "guides.descriptions.cline",
	"/guides/continue": "guides.descriptions.continueCli",
	"/guides/hermes-agent": "guides.descriptions.hermesAgent",
	"/guides/kilo-code": "guides.descriptions.kiloCode",
	"/guides/kimi-code": "guides.descriptions.kimiCode",
	"https://docs.doteb.com/guides/n8n": "guides.descriptions.n8n",
	"/guides/opencode": "guides.descriptions.opencode",
	"/guides/opencode-desktop": "guides.descriptions.opencodeDesktop",
	"/guides/openclaw": "guides.descriptions.openclaw",
	"/guides/pi": "guides.descriptions.pi",
	"#": "guides.descriptions.vscode",
};

export function GuidesGrid({ uiUrl }: { uiUrl: string }) {
	const { t } = useI18n();

	const guides = useMemo<IntegrationGuide[]>(
		() =>
			DEFAULT_INTEGRATION_GUIDES.map((guide) => ({
				...guide,
				description: GUIDE_DESCRIPTION_KEYS[guide.href]
					? t(GUIDE_DESCRIPTION_KEYS[guide.href])
					: guide.description,
				badge:
					guide.badge === "Plan mode only"
						? t("guides.planModeOnly")
						: guide.badge,
			})),
		[t],
	);

	const copy = useMemo(
		() => ({
			comingSoon: t("guides.comingSoon"),
			searchPlaceholder: t("guides.searchPlaceholder"),
			searchAriaLabel: t("guides.searchAriaLabel"),
			noResultsTitle: (query: string) => t("guides.noResultsTitle", { query }),
			noResultsDescription: t("guides.noResultsDescription"),
		}),
		[t],
	);

	return (
		<IntegrationGuidesGrid
			guides={guides}
			copy={copy}
			internalHrefPrefix={uiUrl}
		/>
	);
}
